var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',[_c('router-link',{attrs:{"to":{name:'play/season-1/level-1'}}},[_vm._v("Level 1")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }